import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { clearLoadedVisit } from '../actions';
import { VISIT_AND_UNITS } from '../constants/actionTypes';


function *_clearVisitOnFormReset(action) {
    if (action.form !== 'visit') {
        return;
    }

    yield put(clearLoadedVisit());
}


export function *clearVisitOnFormReset() {
    yield takeLatest('redux-form/RESET', _clearVisitOnFormReset);
}